export default __webpack_public_path__ + "static/media/drops_transparent.22c9bc05.gif";